
import InformationButton from "@/components/InformationButton.vue";
import { useCart } from "@/store/store";

export default {
  components: {
    InformationButton
  },
  setup() {
    const { getCartCounts } = useCart();
    return {
      counts: getCartCounts
    };
  }
};
